import React, { FC, Dispatch, SetStateAction } from 'react'
import { CustomField, LoadingButton } from 'src/ui'
import {
  Dialog,
  Button,
  Theme,
  DialogTitle,
  DialogContent,
  Box,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import { Form, Field } from 'react-final-form'
import { validateFormWithSchema } from 'src/core'
import * as yup from 'yup'
import {
  email,
} from 'src/helpers/schema'

const StyledButton = styled(Button)(({ theme }) => ({
  '&:not(:last-child)': {
    marginRight: (theme as Theme).spacing(2)
  }
}))

const Root = styled('form')({
  width: '400px'
})

const FieldWrapper = styled('div')<Theme>(({ theme }) => ({
  marginBottom: theme.spacing(2)
}))

const emailSchema = yup.object().shape({
  email,
})

const ButtonsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: (theme as Theme).spacing(1),
  marginBottom: (theme as Theme).spacing(1)
}))

interface TProps {
  onClose: () => void,
  setEmail: Dispatch<SetStateAction<String>>,
  onSubmit: (user: {}) => void,
  loading: boolean,
  mutationError: boolean,
  isOpen: boolean,
  workspaceName: String,
}

const validateForm = validateFormWithSchema({ schema: emailSchema })

export const TransferWorkspaceModal: FC<TProps> = ({
  loading,
  workspaceName,
  isOpen,
  setEmail,
  onClose,
  onSubmit,
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle>
        {`Are you sure you want to transfer this workspace: ${workspaceName}?`}
      </DialogTitle>
      <DialogContent>
        <Form
          initialValues={{
            email: null
          }}
          onSubmit={onSubmit}
          validate={validateForm}
        >
          {({ handleSubmit, submitting }) => (
            <Root onSubmit={handleSubmit}>
              <Field name='email'>
                {({ input, meta }) => (
                  <FieldWrapper>
                    <CustomField
                      errorMessage={meta.touched && (meta.error || meta.submitError)}
                      fullWidth
                      inputProps={input}
                      label='Email'
                      onBlur={(data) => setEmail(data.target.value)}
                    />
                  </FieldWrapper>
                )}
              </Field>
              <ButtonsWrapper>
                <LoadingButton
                  color='primary'
                  disabled={submitting || loading}
                  loading={submitting || loading}
                  style={{ marginRight: 20 }}
                  type='submit'
                  variant='contained'
                >
                  Transfer Ownership
                </LoadingButton>
                <StyledButton
                  onClick={onClose}
                  type='button'
                  variant='contained'
                >
                  Cancel
                </StyledButton>
              </ButtonsWrapper>
            </Root>
          )}
        </Form>
      </DialogContent>
    </Dialog>
  )
}
